/**
 * @generated SignedSource<<ed45c61631c74101f45fea7eca4e5ffa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type rulesPage_ImportPollQuery$variables = {
  id: string;
};
export type rulesPage_ImportPollQuery$data = {
  readonly multiUpload: {
    readonly errorMessage: string | null | undefined;
    readonly phase: string | null | undefined;
    readonly state: string;
  } | null | undefined;
};
export type rulesPage_ImportPollQuery = {
  response: rulesPage_ImportPollQuery$data;
  variables: rulesPage_ImportPollQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phase",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errorMessage",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "rulesPage_ImportPollQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MultiUpload",
        "kind": "LinkedField",
        "name": "multiUpload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "rulesPage_ImportPollQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MultiUpload",
        "kind": "LinkedField",
        "name": "multiUpload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0495e90277610604bce6e1b1cf17eecb",
    "id": null,
    "metadata": {},
    "name": "rulesPage_ImportPollQuery",
    "operationKind": "query",
    "text": "query rulesPage_ImportPollQuery(\n  $id: ID!\n) {\n  multiUpload(id: $id) {\n    phase\n    state\n    errorMessage\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "292a8834b66c64f6abba71b92229abb0";

export default node;
